import { useState } from "react";
import { APP_KEY_IDS } from "../../../constants/constants";
import BaseMobileAppContainer from "../base-mobile-app-container/BaseMobileAppContainer";
import Styles from "./MobileSpotify.module.scss";
import NavigationBar from "../navigation-bar/NavigationBar";



import { ReactComponent as SpotifyIcon } from "../../../icons/extra_icons/spotify_icon.svg"
import { ReactComponent as HomeIcon } from "../../../icons/extra_icons/home.svg"
import { ReactComponent as SearchIcon } from "../../../icons/extra_icons/search.svg"
import { ReactComponent as SpotifyAddIcon } from "../../../icons/extra_icons/spotify_add.svg"
import { ReactComponent as LibraryIcon } from "../../../icons/extra_icons/spotify_library.svg"
import BottomOptions from "../botttom-options/BottomOptions";
import { getCurrentOption } from "../../../global/functions/functrions";
import SearchScreen from "./search/SearchScreen";
import BuyPremium from "./buyd-premium/BuyPremium";
import Library from "./library/Library";

const MobileSpotify = () => {

  const [activeOption, setActiveOption] = useState<any>("2");
  const [activeLink, setActiveLink] = useState<any>("");

  const playlists = [
    {
      options: [
        {
          id: "4",
          label: "Top Indian Hits",
          link: "https://open.spotify.com/embed/playlist/37i9dQZEVXbMWDif5SCBJq?utm_source=generator"
        },
        {
          id: "5",
          label: "Top Global",
          link: "https://open.spotify.com/embed/playlist/37i9dQZEVXbMDoHDwVN2tF?utm_source=generator"
        },
        {
          id: "6",
          label: "Top Indian",
          link: "https://open.spotify.com/embed/playlist/37i9dQZEVXbLZ52XmnySJg?utm_source=generator"
        },
        {
          id: "7",
          label: "Viral",
          link: "https://open.spotify.com/embed/playlist/37i9dQZEVXbLiRSasKsNU9?utm_source=generator"
        },
        {
          id: "8",
          label: "My Playlist",
          link: "https://open.spotify.com/embed/playlist/5TOGeO4uRSnxGasvJDy7iG?utm_source=generator&theme=0"
        },
        {
          id: "9",
          label: "Audiobooks",
          link: "https://open.spotify.com/embed/show/6R76Hw6GPIX8AnFXE9UtWf?utm_source=generator&theme=0&t=0"
        },
        {
          id: "10",
          label: "Funny",
          link: "https://open.spotify.com/embed/playlist/5NF6YWCUxyZlZO96A3PHym?utm_source=generator"
        },
        {
          id: "11",
          label: "Ted Talks",
          link: "https://open.spotify.com/embed/playlist/6VouoU8EkWdkxoyfWKXOE7?utm_source=generator"
        },
      ]
    },
  ]

  const menuItem = [
    {
      id: "0",
      label: "Home",
      icon: <HomeIcon />
    },
    {
      id: "1",
      label: "Search",
      icon: <SearchIcon />
    },
    {
      id: "2",
      label: "Library",
      icon: <LibraryIcon />
    },
    {
      id: "3",
      label: "Premium",
      icon: <SpotifyIcon />
    },
  ]

  const getCurrentMainScreen = ()=>{

    switch(getCurrentOption(activeOption)){
      case "0":return <div className={Styles.home_container}>Check library</div>
      case "1":return <SearchScreen/>
      case "2":return <Library activeLink={activeLink} data={playlists[0].options} onClickOption={setActiveLink}/>
      case "3":return <BuyPremium/>
      default: setActiveOption("2")
    }

  }

  // async function fetchPlaylistDataFromEmbedLink(embedLink:any="6VouoU8EkWdkxoyfWKXOE7") {
  //   try {
  //     // Extract the playlist ID from the embed link
  //     // const playlistId = embedLink.match(/playlist\/(\w+)/)[1];
  //     let playlistId="6VouoU8EkWdkxoyfWKXOE7"
    
  //     // Fetch the playlist data from the Spotify Web API
  //     const response = await fetch(`https://api.spotify.com/v1/playlists/${playlistId}`, {
  //       headers: {
  //         'Authorization': 'Bearer 5ddd0a9c96d64fefafda43a6b8720108' // Replace with your access token
  //       }
  //     });
    
  //     if (!response.ok) {
  //       throw new Error('Unable to fetch playlist data from Spotify.');
  //     }
    
  //     const data = await response.json();


  //     console.log("Data is : ",data)
    
  //     // Extract the necessary information from the data
  //     const playlistName = data.name;
  //     const playlistCoverUrl = data.images[0].url; // Assuming the playlist has at least one image
      
  //     // Perform any desired actions with the playlist data
  //     console.log(`Playlist Name: ${playlistName}`);
  //     console.log(`Playlist Cover URL: ${playlistCoverUrl}`);
    
  //     return data; // Return the fetched playlist data if needed
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }
  

  const handleBackClick = ()=>{
      setActiveLink("")
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.content}>
        {getCurrentMainScreen()}
      </div>
      <div className={Styles.footer}>
        <BottomOptions activeTabId={activeOption} contentArray={menuItem} onOptionClick={setActiveOption}/>
      </div>
      <div className={Styles.navigatiuon}>
        <NavigationBar appId={APP_KEY_IDS.MOBILE_SPOTIFY} forceDarkMode={true} onBackClick={activeLink && handleBackClick }/>
      </div>
    </div>
  )
}

export default MobileSpotify
